import { doc, getDoc, getFirestore } from 'firebase/firestore';
import { openDB } from 'idb';
import { app } from '../firebase.js';

const firestore = getFirestore(app);

export async function fetchVersionData(versionData) {
    const versionDocRef = doc(firestore, 'data', 'versions');
    let versionDocSnap;
    if (versionData) {
        versionDocSnap = versionData;
    } else {
        versionDocSnap = (await getDoc(versionDocRef)).data();
    }

    return versionDocSnap;
}

async function retreiveVersionData(versionData, setVersionData, db, dataName) {
    const versionDocRef = doc(firestore, 'data', 'versions');
    let versionDocSnap;
    if (versionData) {
        versionDocSnap = versionData;
    } else {
        versionDocSnap = (await getDoc(versionDocRef)).data();
        setVersionData(versionDocSnap);
    }

    let firestoreVersion = versionDocSnap[`${dataName}`];
    let indexedDBVersion = await db.get('firestore-cache', `data-versions-${dataName}`);
    return { firestoreVersion: firestoreVersion, indexedDBVersion: indexedDBVersion }
}

export async function saveData(data, dataName, dataPrefix, db = null) {
    if (!db) {
        db = await openDB('firestore-cache-db', 1, {
            upgrade(db) {
                db.createObjectStore('firestore-cache');
            },
        });
    }

    await db.put('firestore-cache', data, `${dataPrefix}-${dataName}`);
}

async function fetchData(dataName) {
    const dataDocRef = doc(firestore, 'data', `${dataName}`);
    let dataDocSnap = await getDoc(dataDocRef);
    let data = dataDocSnap.data();
    return data;
}

export async function fetchGenericData(versionData, setVersionData, dataName) {
    const db = await openDB('firestore-cache-db', 1, {
        upgrade(db) {
            db.createObjectStore('firestore-cache');
        },
    });

    const { firestoreVersion, indexedDBVersion } = await retreiveVersionData(versionData, setVersionData, db, dataName);

    let data;
    let versionUpdated = false;

    if (!indexedDBVersion || firestoreVersion !== indexedDBVersion) {
        data = await fetchData(dataName);
        await saveData(data, dataName, 'data', db);
        versionUpdated = true;

    } else if (firestoreVersion === indexedDBVersion) {
        data = await db.get('firestore-cache', `data-${dataName}`);
        if (!data) {
            data = await fetchData(dataName);
            await saveData(data, dataName, 'data', db);
            versionUpdated = true;
        }
    }


    if (firestoreVersion !== indexedDBVersion) {
        await saveData(firestoreVersion, dataName, 'data-versions', db)
    }

    return { data, versionUpdated };
}

